import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { ProviderStudioListItem } from "@shared-kernel/application/ports/provider/provider-repository";

export const retrieveProviderStudio = createAsyncThunk<ProviderStudioListItem, string, { extra: Partial<Dependencies> }>(
  "provider/studio/retrieve",
  async (id, { extra: { providerRepository } }) => {
    return providerRepository!.getStudioById(id);
  },
);

export const resetRetrieveProviderStudio = createAction("provider/studio/resetRetrieve");
